module.exports = __webpack_public_path__ + "56fce12dd2bad8dc6c8ba4b28f54dfb8.jpg";